export default "__VITE_ASSET__DeZJPqEv__"